import './WhitePopUpStyles.css';

import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FocusLock from 'react-focus-lock';
import { Link } from 'react-router-dom';

import { Button } from '../../components/button/Button';
import useKeyboardAction from '../../hooks/useKeyboardAction';

interface LinkButton {
  link: string;
  text: string;
  state?: string;
}

interface NotLinkButton {
  handleClick: () => void;
  text: string;
}

// Type guard function to check if button is LinkButton
function isLinkButton(button: LinkButton | NotLinkButton): button is LinkButton {
  return 'link' in button;
}

interface WhitePopUpWithLinksProps {
  popUpContents: {
    title?: string;
    heading?: string;
    paragraphs: string[];
    backBtn: LinkButton | NotLinkButton;
    continueBtn: LinkButton | NotLinkButton;
  };
  dialogTitle: string;
  enableEscape?: boolean;
}

function WhitePopUpWithLinks({
  popUpContents,
  dialogTitle,
  enableEscape = false,
}: WhitePopUpWithLinksProps) {
  const { title, heading, paragraphs, backBtn, continueBtn } = popUpContents;

  useKeyboardAction(() => {
    if (enableEscape && !isLinkButton(backBtn)) {
      backBtn.handleClick();
    }
  }, 'Escape');

  return (
    <FocusLock>
      <div className="popup-overlay" role="dialog" aria-modal="true" aria-labelledby="modal-title">
        <span className="sr-only">{dialogTitle}</span>
        <div className="popup-container">
          <h2 className="popup-title" id="modal-title">
            {title ? `${title} ${dialogTitle}` : dialogTitle}
          </h2>
          <div className="popup-body">
            {heading && <div className="popup-heading">{heading}</div>}
            <div className="popup-text-container">
              {paragraphs.map((item, index) => (
                <p key={index}>{item}</p>
              ))}
            </div>
          </div>
          <div className="popup-cta">
            {[backBtn, continueBtn].map((btn, index) =>
              isLinkButton(btn) ? (
                <Link
                  to={btn.link}
                  className={`btn btn-primary ${index === 0 ? 'btn-pink' : 'btn-blue'}`}
                  key={index}
                  state={btn.state ?? null}
                >
                  {index === 0 && <FontAwesomeIcon icon={faArrowLeft} className="button-icon" />}
                  {btn.text}
                </Link>
              ) : (
                <Button
                  key={index}
                  onClick={() => {
                    btn.handleClick();
                  }}
                  icon={index === 0 ? { faIconDefinition: faArrowLeft } : null}
                  color={index === 0 ? 'pink' : 'blue'}
                >
                  {btn.text}
                </Button>
              )
            )}
          </div>
        </div>
      </div>
    </FocusLock>
  );
}

export default WhitePopUpWithLinks;
